// extracted by mini-css-extract-plugin
export default {"none":"BrLsm8+ECY"};